import React, { useState } from "react";
import CouponsForm from "./CouponsForm";
import { addCoupon } from "../../api/couponService";
export default function AddCoupon() {
  const [loading, setLoading] = useState(false);
  const handleAdd = async (payload) => {
    setLoading(true);
    try {
      const res = await addCoupon(payload);
      return res;
    } catch (err) {
      throw err;
    } finally {
      setLoading(false);
    }
  };
  return (
    <CouponsForm
      onSubmit={handleAdd}
      loading={loading}
      isEdit={false}
    />
  );
}